//uses customSelect Plugin => https://kvlsrg.github.io/jquery-custom-select/
import API from './api';
class News extends API {
    tmpl_endpoint = '/wp-json/wp/v2/news-template'
    api_endpoint = '/wp-json/wp/v2/news'
    resultsContainer = $('.results__results')
    paginationContainer = $('.results__pagination')
    itemTmpl = null;

    constructor() {
        super()
        this.getTemplate(this.tmpl_endpoint)
    }

    async getTemplate(tmpl) {
        this.itemTmpl = await this.fetchTemplate(tmpl)
        this.initFormHandling()
        this.loadNews([], null, false)
    }

    initFormHandling() {
        let _t = this

        _t.searchContainer.on('submit', function(e) {
            e.preventDefault()
            _t.searchContainer.find('.multi-select .label').removeClass('open').next('.multi-select-dropdown').fadeOut(200);
            _t.loadNews($(this).serializeArray(), 1)
        })

        _t.paginationContainer.on('click', 'a', function(e) {
            e.preventDefault()
            let page = $(this).data('page')
            _t.loadNews(_t.searchContainer.serializeArray(), page)
        })

        _t.sort.on('change', function() {
            _t.loadNews(_t.searchContainer.serializeArray(), 1)
        })
    }

    async loadNews(formData = [], page = 1, scroll = true) {
        let _t = this
        let queryParams = { page: page }

        if(scroll) _t.scrollToTop()
        _t.resultsContainer.empty().append('<div class="loader"></div>')
        
        formData.forEach(item => {
            if(item.value !== 'null' && item.value !== '') {
                if (queryParams[item.name]) {
                    queryParams[item.name].push(item.value)
                } else {
                    queryParams[item.name] = [item.value]
                }
            }
        })

        let sortOrder = _t.sort.val();
        if (sortOrder) queryParams['sort'] = sortOrder

        _t.fetchAPI(_t.api_endpoint, queryParams)
            .then(response => {
                $('.results__count').html(response.total + ' Result(s)')
                _t.renderNews(response.news)
                _t.renderPagination(response.total_pages, response.current_page)
            })
            .catch(err => {
                console.error('Failed to load news', err)
                _t.resultsContainer.empty().append('<p>Failed to load news.</p>')
            })
    }

    renderNews(resources) {
        this.resultsContainer.empty()

        if (resources.length > 0) {
            resources.forEach(resource => {
                let resourceItem = $(this.itemTmpl
                    .replaceAll('{{title}}', resource.title)
                    .replaceAll('{{date}}', resource.date)
                    .replaceAll('{{href}}', resource.link)
                    .replaceAll('{{image}}', resource.featured_image)
                    .replaceAll('{{excerpt}}', resource.excerpt)
                    .replaceAll('{{tag}}', resource.category[0])
                )

                if(!resource.featured_image) resourceItem.find('.image img').remove()
                this.resultsContainer.append(resourceItem)
            })
        } else {
            this.resultsContainer.append('<p>No resources found.</p>')
        }
    }

    
}

$(() => {
    if ($('.news').length) new News()
})
